const apiBase = process.env.REACT_APP_API_URL || '';

// Remove trailing slash para evitar // entre base e path
export const API_BASE_URL = apiBase.endsWith('/') ? apiBase.slice(0, -1) : apiBase;

export const apiUrl = (path) => `${API_BASE_URL}${path}`;
